<ng-template [uiDrawerTitle]>
  <div class="thread-drawer-header" *ngIf="!indicators.getItem">
    <i class="icon-metric fs-16px sp-mr-5" [a11yTitle]="'key_result' | localize" ui-icon uiType="metric" uiTheme="fill"></i>
    <div>{{ "discuss_key_result_upd" | localize }} {{ metric.name }}</div>
  </div>
</ng-template>

<gh-indicator [ghValue]="indicators.getItem" [ghMessage]="'loading' | localize"></gh-indicator>

<div *ngIf="!indicators.getItem">
  <div class="sp-mb-2" id="message" *ngIf="params.targetType === 'checkin'">
    <div id="metric-preview">
      <div class="metric-snapshots sp-mb-2" *ngIf="metricSnapshot">
        <metric-snapshot-previews [snapshot]="metricSnapshot" [metric]="metric"></metric-snapshot-previews>
      </div>
      <div class="reactions-with-show-comments">
        <reactions [(reactions)]="snapshotReactions" [target]="metricSnapshot" targetType="checkin"></reactions>
        <show-comments-button [commentsCount]="commentsCount" onPageUsed="thread"></show-comments-button>
      </div>
    </div>
  </div>

  <comments
    *ngIf="featureAvailable('comments')"
    [isNewCommentOnTop]="true"
    [target]="{ id: params.targetId, type: params.targetType, title: commentTargetTitle }"
    [initialMentions]="commentMentions"
    [metadata]="metadata"
    [inputPlaceholder]="'comment_on_key_result_update' | localize"
    (cancel)="onCancel()"></comments>
</div>
